import { render, staticRenderFns } from "./secondadd.vue?vue&type=template&id=fb10e9b8&scoped=true&"
import script from "./secondadd.vue?vue&type=script&lang=js&"
export * from "./secondadd.vue?vue&type=script&lang=js&"
import style0 from "./secondadd.vue?vue&type=style&index=0&id=fb10e9b8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb10e9b8",
  null
  
)

export default component.exports